import React from "react";

const NotFound = () => {
  return <p>your heart is not found</p>;
};

export default NotFound;
